import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["VoltageLevel"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getVoltageLevel: build.query<
        GetVoltageLevelApiResponse,
        GetVoltageLevelApiArg
      >({
        query: () => ({ url: `/VoltageLevel` }),
        providesTags: ["VoltageLevel"],
      }),
      putVoltageLevelByName: build.mutation<
        PutVoltageLevelByNameApiResponse,
        PutVoltageLevelByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/VoltageLevel/${queryArg.name}`,
          method: "PUT",
          body: queryArg.voltageLevelDto,
        }),
        invalidatesTags: ["VoltageLevel"],
      }),
      deleteVoltageLevelByName: build.mutation<
        DeleteVoltageLevelByNameApiResponse,
        DeleteVoltageLevelByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/VoltageLevel/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["VoltageLevel"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as voltageLevelApi };
export type GetVoltageLevelApiResponse = /** status 200 OK */ VoltageLevelDto[];
export type GetVoltageLevelApiArg = void;
export type PutVoltageLevelByNameApiResponse = /** status 200 OK */ void;
export type PutVoltageLevelByNameApiArg = {
  name: string;
  voltageLevelDto: VoltageLevelDto;
};
export type DeleteVoltageLevelByNameApiResponse = unknown;
export type DeleteVoltageLevelByNameApiArg = string;
export type VoltageLevelDto = {
  name: string;
  value?: number;
  comment?: string | null;
  isUsed: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetVoltageLevelQuery,
  useLazyGetVoltageLevelQuery,
  usePutVoltageLevelByNameMutation,
  useDeleteVoltageLevelByNameMutation,
} = injectedRtkApi;
